import script from "./CourseInquiryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseInquiryModal.vue?vue&type=script&setup=true&lang=js"

import "./CourseInquiryModal.vue?vue&type=style&index=0&id=198b732c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198b732c"]])

export default __exports__